/**
 * Changelog — HARDCODED einträge (bewusst: kein Backend, jeder sieht dasselbe).
 * Neuen Eintrag IMMER OBEN anfügen; `id` eindeutig lassen — das Gelesen-System
 * vergleicht die neueste id mit localStorage.
 */

export type ChangelogType = 'NEU' | 'UPDATE' | 'FIX' | 'WICHTIG';

export interface ChangelogEntry {
  id: string;
  date: string; // Anzeige, z.B. "19. August 2026"
  type: ChangelogType;
  title: string;
  summary: string;
  /** Hardcoded HTML — wird 1:1 gerendert (eigener, vertrauenswürdiger Inhalt). */
  html: string;
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    id: '2026-08-19-changelog',
    date: '19. August 2026',
    type: 'NEU',
    title: 'Changelog mit Gelesen-Anzeige',
    summary: 'Diese Seite — alle Updates an einem Ort, neue Einträge werden in der Sidebar markiert.',
    html: `
      <p>Ab jetzt findest du alle Neuerungen hier. Gibt es einen neuen Eintrag, pulsiert das Megafon-Symbol unten in der Sidebar, bis du die Seite öffnest.</p>
      <ul>
        <li>Einträge als kompakte Badges untereinander — Klick öffnet die Details</li>
        <li>Gelesen-Status pro Browser (kein Konto-Sync nötig)</li>
      </ul>`,
  },
  {
    id: '2026-08-18-mobile-app',
    date: '18. August 2026',
    type: 'NEU',
    title: 'Vyndesk Mobile App (Beta, iOS)',
    summary: 'Tickets, KI-Entwürfe, Dashboard und Telefon — jetzt auch unterwegs.',
    html: `
      <p>Die neue iOS-App verbindet sich per QR-Code mit deinem Desk: <strong>Einstellungen → Mobile App</strong> öffnen und den Code scannen.</p>
      <ul>
        <li>Ticket-Liste mit deinen eigenen und geteilten Ansichten</li>
        <li>Ticket-Detail: Antworten, interne Notizen, KI-Antworten, Bestellungen, Zusammenführen, Übersetzung</li>
        <li>KI-Entwürfe prüfen, überarbeiten und senden</li>
        <li>Telefon: Anrufe führen und annehmen, Aufnahmen und KI-Zusammenfassungen</li>
        <li>Cloud-Agent starten/stoppen — live synchron mit dem Web</li>
      </ul>`,
  },
  {
    id: '2026-08-17-whiteboard',
    date: '17. August 2026',
    type: 'NEU',
    title: 'Meetings: Whiteboard',
    summary: 'Gemeinsames Zeichnen und Präsentieren direkt im Meeting.',
    html: `
      <p>In jedem Meeting gibt es jetzt ein interaktives Whiteboard — über das Präsentations-Symbol in der Leiste. Auch Gäste können mitzeichnen.</p>`,
  },
  {
    id: '2026-08-16-meet-ansichten',
    date: '16. August 2026',
    type: 'UPDATE',
    title: 'Meetings: Neue Ansichten',
    summary: 'Aktiver Sprecher, Rasteransicht und Anheften einzelner Teilnehmer.',
    html: `
      <ul>
        <li><strong>Aktiver Sprecher</strong> (Standard): wer spricht, wird automatisch groß gezeigt</li>
        <li><strong>Raster</strong>: alle Teilnehmer gleichzeitig im Blick</li>
        <li><strong>Anheften</strong>: Klick auf eine Kachel fixiert die Person</li>
        <li>Bildschirmfreigaben werden automatisch angeheftet</li>
      </ul>`,
  },
  {
    id: '2026-08-15-editor-resize',
    date: '15. August 2026',
    type: 'UPDATE',
    title: 'Ticket-Detail: Editor-Höhe anpassbar',
    summary: 'Der Antwort-Editor lässt sich per Ziehen vergrößern — die Höhe bleibt gespeichert.',
    html: `
      <p>Zwischen Verlauf und Editor gibt es jetzt einen Ziehgriff. Die gewählte Höhe gilt für alle Tickets und bleibt auch nach dem Neuladen erhalten.</p>`,
  },
  {
    id: '2026-08-14-suche-bestellnummern',
    date: '14. August 2026',
    type: 'FIX',
    title: 'Suche: Bestellnummern mit #',
    summary: 'Bestellnummern werden jetzt zuverlässig gefunden — mit und ohne #.',
    html: `
      <p>Die Suche nach Bestellnummern (z.B. <code>#552510659</code>) übersieht keine Treffer mehr; auch ältere Tickets sind vollständig indexiert.</p>`,
  },
  {
    id: '2026-08-13-login',
    date: '13. August 2026',
    type: 'UPDATE',
    title: 'Neue Login-Seite',
    summary: 'Frisches Design im Stil der neuen Vyndesk-Oberfläche.',
    html: `
      <p>Die Anmeldeseite wurde neu gestaltet — klarer, schneller, mit dem gewohnten Look der Ticketverwaltung.</p>`,
  },
];

export const LATEST_CHANGELOG_ID = CHANGELOG[0]?.id ?? '';

const SEEN_KEY = 'changelog.lastSeenId';
export const CHANGELOG_SEEN_EVENT = 'changelog-seen';

export function isChangelogUnread(): boolean {
  try {
    return localStorage.getItem(SEEN_KEY) !== LATEST_CHANGELOG_ID;
  } catch {
    return false;
  }
}

export function markChangelogSeen(): void {
  try {
    localStorage.setItem(SEEN_KEY, LATEST_CHANGELOG_ID);
  } catch {
    /* private mode vs. — sessizce geç */
  }
  window.dispatchEvent(new Event(CHANGELOG_SEEN_EVENT));
}
